import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { HiChevronDown, HiShare } from 'react-icons/hi';

import { useDownloadPdf } from '../hooks/useDownloadPdf';
import { EmailRequestProps, useEmailRequest } from '../hooks/useEmailRequest';

export const ShareButton = ({ requestId, type }: EmailRequestProps) => {
  const { handleDownloadPdf, isLoading: isDownloading } = useDownloadPdf();
  const { handleEmailRequest, isLoading: isEmailSending } = useEmailRequest({ requestId, type });

  return (
    <Menu>
      <MenuButton
        variant={type === 'Update' ? 'ghost' : undefined}
        leftIcon={<HiShare />}
        rightIcon={<HiChevronDown />}
        as={Button}
        isLoading={isEmailSending || isDownloading}
      >
        Share
      </MenuButton>
      <MenuList>
        <MenuItem onClick={handleDownloadPdf}>Download</MenuItem>
        <MenuItem onClick={handleEmailRequest}>Email Me</MenuItem>
      </MenuList>
    </Menu>
  );
};
